'use client';

import { getBackendGraphqlApiConfig } from './get-backend-graphql-config';
import { makeApolloClient } from './create-apollo-client';

import { getRuntimeEnvironment } from '@/environment/get-runtime-environment';

export const makeClientSideApolloClient = () => {
  const env = getRuntimeEnvironment(window.location.origin);

  const config = getBackendGraphqlApiConfig(env);

  return makeApolloClient(config);
};
